import { instancePerContainerCachingFactory, registry } from 'tsyringe';
import {
  ICondition,
  kNameOfCondition,
} from '../services/content-recommendation-service/conditions/interfaces/condition.interface';
import { GlobalConditionCooldownFromLastNotification } from '../services/content-recommendation-service/conditions/global-condition-cooldown-last-notification';
import { ConditionApplicationExcluded } from '../services/content-recommendation-service/conditions/condition-application-excluded';
import { ConditionApplicationAlreadyInstalled } from '../services/content-recommendation-service/conditions/condition-application-already-installed';
import { ConditionBlacklistApplicationInstalled } from '../services/content-recommendation-service/conditions/condition-blacklist-application-installed';
import { ConditionDedicatedAppInstalled } from '../services/content-recommendation-service/conditions/condition-dedicated-application-installed';
import { ConditionGeoRestricted } from '../services/content-recommendation-service/conditions/condition-geo-restricted';
import { ConditionGPUSupported } from '../services/content-recommendation-service/conditions/condition-gpu-supported';
import { ConditionNotificationDisplayCap } from '../services/content-recommendation-service/conditions/condition-notification-display-cap';
import { ConditionNotificationPreviouslyDismissed } from '../services/content-recommendation-service/conditions/condition-notification-previously-dismissed';
import { GlobalConditionCooldownFromInstall } from '../services/content-recommendation-service/conditions/global-condition-cooldown-install';
import { GlobalConditionCooldownOwLaunch } from '../services/content-recommendation-service/conditions/global-condition-cooldown-ow-launch';
import { GlobalConditionGameExcluded } from '../services/content-recommendation-service/conditions/global-condition-game-excluded';
import { GlobalConditionGameRunning } from '../services/content-recommendation-service/conditions/global-condition-game-running';
import { GlobalConditionUserPhasing } from '../services/content-recommendation-service/conditions/global-condition-user-phasing';
import { ConditionExtensionPhasing } from '../services/content-recommendation-service/conditions/condition-extension-phasing';
import { ConditionPlatformDisabled } from '../services/content-recommendation-service/conditions/condition-platform-disabled';
import { ConditionHostApp } from '../services/content-recommendation-service/conditions/condition-approved-host-app';
import { ConditionGameInfoReceived } from '../services/content-recommendation-service/conditions/condition-game-info-received';

@registry([
  // ---------------------------------------------------------------------------
  {
    token: kNameOfCondition,
    useFactory: instancePerContainerCachingFactory<ICondition>((c) => {
      return c.resolve(GlobalConditionCooldownOwLaunch);
    }),
  },
  // ---------------------------------------------------------------------------
  {
    token: kNameOfCondition,
    useFactory: instancePerContainerCachingFactory<ICondition>((c) => {
      return c.resolve(GlobalConditionCooldownFromInstall);
    }),
  },
  // ---------------------------------------------------------------------------
  {
    token: kNameOfCondition,
    useFactory: instancePerContainerCachingFactory<ICondition>((c) => {
      return c.resolve(GlobalConditionCooldownFromLastNotification);
    }),
  },
  // ---------------------------------------------------------------------------
  {
    token: kNameOfCondition,
    useFactory: instancePerContainerCachingFactory<ICondition>((c) => {
      return c.resolve(GlobalConditionGameRunning);
    }),
  },
  // ---------------------------------------------------------------------------
  {
    token: kNameOfCondition,
    useFactory: instancePerContainerCachingFactory<ICondition>((c) => {
      return c.resolve(GlobalConditionUserPhasing);
    }),
  },
  // ---------------------------------------------------------------------------
  {
    token: kNameOfCondition,
    useFactory: instancePerContainerCachingFactory<ICondition>((c) => {
      return c.resolve(ConditionPlatformDisabled);
    }),
  },
  // ---------------------------------------------------------------------------
  {
    token: kNameOfCondition,
    useFactory: instancePerContainerCachingFactory<ICondition>((c) => {
      return c.resolve(ConditionExtensionPhasing);
    }),
  },
  // ---------------------------------------------------------------------------
  {
    token: kNameOfCondition,
    useFactory: instancePerContainerCachingFactory<ICondition>((c) => {
      return c.resolve(ConditionHostApp);
    }),
  },
  // ---------------------------------------------------------------------------
  {
    token: kNameOfCondition,
    useFactory: instancePerContainerCachingFactory<ICondition>((c) => {
      return c.resolve(ConditionNotificationPreviouslyDismissed);
    }),
  },
  // ---------------------------------------------------------------------------
  {
    token: kNameOfCondition,
    useFactory: instancePerContainerCachingFactory<ICondition>((c) => {
      return c.resolve(ConditionApplicationAlreadyInstalled);
    }),
  },
  // ---------------------------------------------------------------------------
  {
    token: kNameOfCondition,
    useFactory: instancePerContainerCachingFactory<ICondition>((c) => {
      return c.resolve(ConditionDedicatedAppInstalled);
    }),
  },
  // ---------------------------------------------------------------------------
  {
    token: kNameOfCondition,
    useFactory: instancePerContainerCachingFactory<ICondition>((c) => {
      return c.resolve(ConditionBlacklistApplicationInstalled);
    }),
  },
  // ---------------------------------------------------------------------------
  {
    token: kNameOfCondition,
    useFactory: instancePerContainerCachingFactory<ICondition>((c) => {
      return c.resolve(ConditionNotificationDisplayCap);
    }),
  },
  // ---------------------------------------------------------------------------
  {
    token: kNameOfCondition,
    useFactory: instancePerContainerCachingFactory<ICondition>((c) => {
      return c.resolve(ConditionGPUSupported);
    }),
  },
  // ---------------------------------------------------------------------------
  {
    token: kNameOfCondition,
    useFactory: instancePerContainerCachingFactory<ICondition>((c) => {
      return c.resolve(ConditionApplicationExcluded);
    }),
  },
  // ---------------------------------------------------------------------------
  {
    token: kNameOfCondition,
    useFactory: instancePerContainerCachingFactory<ICondition>((c) => {
      return c.resolve(GlobalConditionGameExcluded);
    }),
  },
  // ---------------------------------------------------------------------------
  {
    token: kNameOfCondition,
    useFactory: instancePerContainerCachingFactory<ICondition>((c) => {
      return c.resolve(ConditionGeoRestricted);
    }),
  },
  // ---------------------------------------------------------------------------
  {
    token: kNameOfCondition,
    useFactory: instancePerContainerCachingFactory<ICondition>((c) => {
      return c.resolve(ConditionGameInfoReceived);
    }),
  },
])
export class ConditionsRegistry {}
